import SearchFactor from "./SearchFactor";

export default SearchFactor;
